import type { FC } from 'react';
import { useGetAgentArtifactQuery } from '@gonfalon/observability-graphql/hooks';
import { ArtifactChip } from '@gonfalon/observability-ui/components/Artifact';

interface Props {
  projectKey: string;
  projectId: string;
  type: string;
  externalId: string;
}

// Wraps ArtifactChip with a lazy DB fetch for inline tokens that weren't pre-resolved
// in the surrounding ArtifactLookupProvider. Loading and error states render the same
// placeholder chip so layout stays stable; on success the chip hydrates with title,
// status, and url.
export const ArtifactChipLazy: FC<Props> = ({ projectKey, projectId, type, externalId }) => {
  const { data, loading, error } = useGetAgentArtifactQuery({
    variables: { project_id: projectId, type, external_id: externalId },
  });

  const artifact = !loading && !error ? data?.agentArtifact?.artifact : null;

  return (
    <ArtifactChip
      projectKey={projectKey}
      type={type}
      externalId={externalId}
      title={artifact?.title}
      status={artifact?.status}
      url={artifact?.url}
      variant="inline"
      placeholder={!artifact}
    />
  );
};
